import React, {useState} from 'react';
import {NavLink, useRouteMatch} from 'react-router-dom';
import {useMutation, useQuery} from '@apollo/client';
import {updateDelete} from '../../utils/mutation';
import Avatar from '../../components/Avatar';
import Validation from '../../components/Validation';
import {QUERY_USER} from '../Client/graphql';
import {QUERY_INTEREST_LIST} from '../Interest/graphql';
import {MUTATION_TALK_SAVE} from '../Talk/graphql';
import {MUTATION_FRIEND_DELETE, MUTATION_FRIEND_SAVE, QUERY_FRIEND_LIST} from './graphql';
import Icon from '../../components/Icon';
import TalkHow from '../Talk/How';

const FriendAcceptedList = ({onTalk, errorData}) => {
  const [howIsOpen, setHowOpen] = useState(false);

  const {user} = useQuery(QUERY_USER).data;
  const query = useQuery(QUERY_FRIEND_LIST);
  const list = query.data ? query.data.friendList : [];

  const [talkSave, talkSaveResp] = useMutation(MUTATION_TALK_SAVE);

  const [save] = useMutation(MUTATION_FRIEND_SAVE);
  const [del] = useMutation(MUTATION_FRIEND_DELETE, {
    update: (cache, response) => updateDelete(cache, response, {query: QUERY_FRIEND_LIST}),
  });

  const {interestList} = useQuery(QUERY_INTEREST_LIST).data || {interestList: []};
  const themeIds = interestList.map(x => x.themeId);

  return (
    <div className="FriendList my-lg-3">
      <div className="row gx-lg-3 gy-3 align-items-center justify-content-between mb-4">
        <div className="col-auto fw-bold font-4">Друзья ({list.filter(x => x.isAccepted).length})</div>
        <div className="col-auto">
          <button className="btn p-2" onClick={() => setHowOpen(true)}>
            {/* <Icon name="question-circle" size={30} /> */}
            <span>Помощь</span>
          </button>
        </div>
      </div>
      <div className="row gx-lg-4 gy-4">
        {list.map(item => {
          const client = item.client1.user.id === user.id ? item.client2 : item.client1;
          const isAny = client.interests.some(r => themeIds.includes(r.theme.id));

          return (
            <div key={item.id} className="col-4">
              <div className="border rounded bg-white p-2">
                <div className="row align-items-center gx-2 p-2">
                  <div className="col-auto">
                    <Avatar user={client.user} size={50} />
                  </div>
                  <div className="col">
                    <div>{client.user.fullname}</div>
                    <div>
                      {item.isAccepted ? (
                        client.interests.map((x, i) => (
                          <span className="font-2 text-primary" key={x.id}>
                            {i !== 0 ? ', ' : ' '}
                            {x.theme.name}
                          </span>
                        ))
                      ) : item.client1.user.id === user.id ? (
                        <span className="font-2 text-muted">Вы отправили запрос на дружбу</span>
                      ) : (
                        <span className="font-2 text-warning">Вам отправлен запрос на дружбу</span>
                      )}
                    </div>
                  </div>
                </div>
                {item.isAccepted ? (
                  <div>
                    <div className="row gx-2">
                      <div className="col">
                        <button
                          onClick={() => talkSave({variables: {input: {client2: client.id}}})}
                          // disabled={!isAny || !isActive(user)}
                          className="btn w-100 btn-sm btn-primary"
                        >
                          Начать беседу
                        </button>
                      </div>
                      <div className="col">
                        <button
                          onClick={() => del({variables: {input: {id: item.id}}})}
                          className="btn w-100 btn-sm btn-light"
                        >
                          Удалить дружбу
                        </button>
                      </div>
                    </div>
                    <Validation data={talkSaveResp.data} field="client_2" cls="text-center mt-2" />
                  </div>
                ) : item.client1.user.id === user.id ? (
                  <button
                    onClick={() => del({variables: {input: {id: item.id}}})}
                    className="d-block w-100 btn btn-sm btn-light"
                  >
                    Отменить запрос
                  </button>
                ) : (
                  <div className="row gx-2">
                    <div className="col">
                      <button
                        onClick={() => save({variables: {input: {friend: item.client1.id}}})}
                        className="d-block w-100 btn btn-sm btn-warning"
                      >
                        Принять
                      </button>
                    </div>
                    <div className="col">
                      <button
                        onClick={() => del({variables: {input: {id: item.id}}})}
                        className="d-block w-100 btn btn-sm btn-light"
                      >
                        Отклонить
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
      <TalkHow isOpen={howIsOpen} onClose={() => setHowOpen(false)} />
    </div>
  );
};

export default FriendAcceptedList;
